<template>
  <div class="basketpage page">
    
    <div class="columns">
      <div class="column">
        <div class="breadcrumb">
          <router-link to="/">KK</router-link> - <router-link :to="{ name: 'UserPage' }">{{user.username}}</router-link> - <router-link :to="{ name: 'OrderPage', params: { i: order.id } }">Ihre Bestellung</router-link>
          <h1>Ihre Bestellung vom {{ getNiceDate( order.orderdate ) }}</h1>
        </div>
      </div>      
    </div>



    <div class="columns">

      <div class="column" >
        <div class="cart-product-link" v-for="(product, i) in order.orderdata" :key="i">
           <router-link  :to="{ name: 'DetailPage', params: { pg: product.pg, artnr: product.artnr } }">
                <div class="prod-img-container">
                  <img v-if="product.bild != '' && ImageExist( '/upload/product-images/' + product.bild ) " :src=" '/upload/product-images/' + product.bild ">
                  <img class="placholder" v-else :src=" product.bio == 'J' ? '/upload/product-images/platzhalter_bio_bw.png':'/upload/product-images/platzhalter_artikelohnefoto.svg' ">
                </div>
            <div class="p-name p-detail">{{product.bez1}} <span v-if="product.vari">{{product.vari}}</span></div>
            </router-link>
            <div class="p-vpe p-detail">{{product.fmng}} {{product.me}} {{ product.vpe != "lose" ? product.vpe : '' }}</div>
            <div class="p-detail">x</div>
            <div class="p-count p-detail">{{product.count}}</div>
            <div class="p-notes p-detail"><textarea readonly="readonly">{{product.notes}}</textarea></div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <button class="button" v-on:click="list2basket">Alles in den Warenkorb legen und diesen bearbeiten</button>
      </div>      
    </div>

  </div>
</template>
<script>
import products from '../data/etar2.json';
  
export default {
    name: 'OrderPage',
    data: function(){
      return {}
    },
    
    created: function(){},
    mounted: function(){},
    computed: {
        user () {
            //console.log(this.$store.state.authentication.user)
            return this.$store.state.authentication.user
        },
      
        order () {
            var res = this.$store.state.orders.all.items.filter((item) => {
                      return ( item.id == this.$route.params.i )
                    });
            //console.log(res[0]);
            return res[0];
                    
        },
    },        
    methods: {
      
      getNiceDate(d){
        var nd = new Date(d)
        return nd.toLocaleDateString();
      },
      
      list2basket(){

        this.order.orderdata.forEach( (p,x) => {

              var schonDrin = this.$store.state.authentication.user.basket.filter( (basketItem) => { return basketItem.artnr == p.artnr });
              if( schonDrin.length < 1 ) {
                this.$store.state.authentication.user.basket.push(p)
              } else {
                schonDrin[0].count = schonDrin[0].count + p.count
              }

        })
//        dispatch('basket/saveNew', { basket });

        //console.log(this.$store.state.authentication.user.basket )
        const basket = this.user.basket;
        const { dispatch } = this.$store;
        dispatch('basket/update', { basket });

        this.$router.push('/basket');
        
      },

      
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           return true //img.width > 0;
        },


    }
}
</script>
<style >
  .cart-product-link { display: flex; align-items: center; width: 100%; flex-wrap: wrap; border-top: 1px solid #ddd; margin: 0;}
  .cart-product-link a { width: 30%; max-width: 20em; display: flex; align-items: center; text-decoration: none !important; border: 0 solid green; }
  .cart-product-link:before { display: none; }
  .cart-product-link .prod-img-container { width: 6em; }
  .cart-product-link .p-detail { padding: 0.9333333em;  color: #00853e; border: 0 solid red; }
  .cart-product-link .p-detail.p-name { font-weight: bold; width: 13em; min-width: 10em;  }
  .cart-product-link .p-detail.p-vpe {  width: 10em; min-width: 10em;  }
  .cart-product-link .p-detail.p-name span { font-weight: normal; display: block;  }
  .cart-product-link .p-detail.p-count { font-weight: bold; color: #dc1200; display: flex;  }
  .cart-product-link .p-detail.p-notes { width: 30%; min-width: 18em; }
  .cart-product-link .p-detail.p-notes textarea { width: 100%; border: 1px solid #ddd; border-radius: 3px; padding: 0.43333333em; outline: 0 !important; transition: border-color 0.2s ease-in-out; }
  .cart-product-link .p-detail.p-notes textarea:focus { border: 1px solid #00853e; }
  .cart-product-link input[type="number"] { width: 3em; text-align: right; margin: 0 0.2333333em }
  .cart-product-link .p-detail.p-remove { width: 3em; }
  
  .basketpage .button { background: #00853e; color: #fff; border: 0; padding: 0.63333em 2.73333333em; border-radius: 3px; text-align: center; width: auto; margin: 0; cursor: pointer; }
</style>